<template>
   <div class="xuanfu" ref="moveDiv" @mousedown.prevent="startDrag" @mousemove="onDrag" @mouseup="stopDrag">
      <img class="img-kf" :src="iconSrc" />
    </div>
</template>

<script>
  export default{
    data(){
      return{
		iconSrc:'/static/images/一一.png',
		isDragging:false,
		startCoords:{x:0,y:0},
		currentCoords:{x:0,y:0},
		debouncedOnDrags:null,
      };
    },
    methods:{
		debounce(func,delay){
			let timer;
			return function(...args){
				if(timer)clearTimeout(timer);
				timer = setTimeout(()=>{
					func.apply(this,args);
				},delay);
			};
		},
		debouncedOnDrag(event){
			this.onDrag(event);
		},
		startDrag(event){
			this.isDragging = true
			this.startCoords = {
				x:event.clientX - this.currentCoords.x,
				y:event.clientY - this.currentCoords.y,
			};
		},
		onDrag(event){
			event.preventDefault();
			if(this.isDragging){
				this.currentCoords = {
					x:event.clientX - this.startCoords.x,
					y:event.clientY - this.startCoords.y,
				};
				// 更新元素位置
				const target = this.$refs.moveDiv;
				target.style.transform = `translate(${this.currentCoords.x}px,${this.currentCoords.y}px)`;
			}
		},
		stopDrag() {
		  this.isDragging = false;
		},
		initDebouncedOnDrag(){
			this.debouncedOnDrags = this.debounce((event)=>{
				this.onDrag(event);
			},16)
		}
	},
	mounted(){
		this.initDebouncedOnDrag();
		document.addEventListener('mousemove',this.debouncedOnDrag);
		document.addEventListener('mouseup',this.stopDrag);
	},
	beforeDestroy(){
		document.removeEventListener('mousemove',this.debouncedOnDrag);
		document.removeEventListener('mouseup',this.stopDrag);
	}
  }
</script>

<style>
 .xuanfu {
    width: 70px;
    height: 70px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
	/* cursor: move; */
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    .img-kf {
      width: 70px;
      height: 90px;
      z-index: 1;
      position: absolute;
      top: 2px;
      left: -1px;
    }
  }
 .xuanfu::before{
    content: '';
    position: absolute;
    left:-5px;
    width: 120%;
    height: 120%;
    rotate: -45deg;
    background: linear-gradient(#81ffef,#8ec1ff,#ff91c8);
  }
  .xuanfu:hover::before{
    animation: rotate 1s linear infinite;
  }
  @keyframes rotate{
    from{
        transform:rotate(0deg)
    }
    to{
        transform:rotate(360deg)
    }
  }
  .xuanfu::after{
      content: '';
      position: absolute;
      background:white;
      inset: 4px;
      border-radius: 50%;
  }

</style>



// WEBPACK FOOTER //
// tools.vue?6cb97358